import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-form-field-formly',
  templateUrl: './form-field-formly.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldFormlyComponent extends FieldWrapper {
  constructor() {
    super();
  }
}
